export const environment = {
  production: false,
  userApiEndpoint: 'https://api-alpha.pklotcorp.com',
  paymentApiEndpoint: 'https://payment-alpha.mochipay.xyz',
  dpassApiEndpoint: 'https://api-alpha.pass.credit',
  dpassAppUrl: 'https://app-alpha.pass.credit',
  termsOfServiceUrl: 'https://www-alpha.pklotcorp.com/terms',
  privacyPolicyUrl: 'https://www-alpha.pklotcorp.com/privacy',
  amplitudeKey: '204c8331cf537c633388945b149b746b',
  openAutopass: 'https://autopass.app.link/fEgVLL6ZzSb',
  DOWNLOAD_AUTOPASS_LINK:
    'autopassapp-alpha://open_collection?need_login=false&poi_collection=carmochi_alpr',
};
